import type { QuestionDefinition } from "@reno-estimator/core";
import { flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion } from "./interior-room-shared.js";

/**
 * Hallway (Phase 13A) - see rules/hallway.ts for the matching calculator.
 * Deliberately the smallest question set in this batch: flooring,
 * painting, trim, and lighting only - no built-ins or windows/doors
 * question, since a hallway/corridor essentially never involves either.
 */
export const hallwayQuestions: QuestionDefinition[] = [
  flooringQuestion("hallway", 200, "hallway"),
  paintingQuestion("hallway", 210),
  trimQuestion("hallway", 220),
  lightingQuestion("hallway", 230)
];
